//
// ModuleActionMenu
//
// Unpublish an action in the ProjectModulesWorksheet

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { VView } from '../appview'
import { Header, Menu, MenuDivider, MenuItem, Text } from '../components'

const ConfirmUnpublishSubmenu = observer(function ConfirmUnpublishSubmenu({
    onAction,
}) {
    const { app } = useStore()

    const _onAction = action => {
        onAction && onAction(action)
    }

    return (
        <VView className="actions-panel" style={{ width: 220 }}>
            <div className="inspector">
                <Header>{app.text('Remove an action')}</Header>
                <Text className="cc-notice">
                    {app.text(
                        'The configuration will no longer be available in Unicat Connect.'
                    )}
                </Text>
            </div>
            <Menu style={{ maxWidth: 220 }}>
                <MenuItem
                    className="cc-danger"
                    onClick={() => _onAction('unpublish_action')}
                >
                    {app.text('Yes, remove the action')}
                </MenuItem>
                <MenuDivider />
                <MenuItem onClick={e => _onAction('cancel')}>
                    {app.text('Cancel')}
                </MenuItem>
            </Menu>
        </VView>
    )
})

export const ModuleActionMenu = observer(function ModuleActionMenu({ onAction }) {
    const { app } = useStore()

    const _onAction = action => {
        onAction && onAction(action)
    }

    return (
        <Menu>
            <MenuItem
                className="cc-notice"
                submenu={<ConfirmUnpublishSubmenu onAction={_onAction} />}
            >
                {app.text('Remove action')}
            </MenuItem>
        </Menu>
    )
})
